import { render, staticRenderFns } from "./ApprovalTrail.vue?vue&type=template&id=6c6006e8&scoped=true"
import script from "./ApprovalTrail.vue?vue&type=script&lang=js"
export * from "./ApprovalTrail.vue?vue&type=script&lang=js"
import style0 from "./ApprovalTrail.vue?vue&type=style&index=0&id=6c6006e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6006e8",
  null
  
)

export default component.exports